var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Documents & Safety/book"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M16.6666 18.3333H5.83331C4.4526 18.3333 3.33331 17.214 3.33331 15.8333M3.33331 15.8333C3.33331 14.4526 4.4526 13.3333 5.83331 13.3333H14.6666C15.7712 13.3333 16.6666 12.4379 16.6666 11.3333V3.33332C16.6666 2.41285 15.9205 1.66666 15 1.66666H5.83331C4.4526 1.66666 3.33331 2.78594 3.33331 4.16666V15.8333ZM15 13.3333V18.3333M6.66665 1.66666V13.3333",
    stroke: "#525D6A",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.19cb8ee9af8ce72d406e5455758654fb.svg";
export { ForwardRef as ReactComponent };